import {
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from '@apollo/orbit';
import React, { useEffect, useRef } from 'react';

import { scrollToIfNotInView } from 'src/lib/scrollTo';

const INFORMATIONAL_NUDGE_TRIGGER_ID = 'informational-nudge';

export const InformationalNudge = ({
  children,
  title,
  description,
  className,
  shouldScrollToIfNotInView = false,
  isOpen,
  onClose,
  ...popoverProps
}: {
  children?: React.ReactElement;
  title: string;
  description: string;
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  shouldScrollToIfNotInView?: boolean;
} & React.ComponentProps<typeof Popover>) => {
  useEffect(() => {
    if (shouldScrollToIfNotInView)
      scrollToIfNotInView(`#${INFORMATIONAL_NUDGE_TRIGGER_ID}`);
  }, [shouldScrollToIfNotInView]);

  const popoverCloseButtonRef = useRef<HTMLDivElement | null>(null);

  return (
    <Popover
      autoFocus
      size="sm"
      isLazy
      initialFocusRef={popoverCloseButtonRef}
      placement="right-end"
      isOpen={isOpen}
      onClose={onClose}
      {...popoverProps}
    >
      <PopoverTrigger>
        {shouldScrollToIfNotInView ? (
          <>
            {
              // popover adds its own id to this trigger, so we add 2 span wrappers
            }
            <span id={INFORMATIONAL_NUDGE_TRIGGER_ID}>{children}</span>
          </>
        ) : (
          children
        )}
      </PopoverTrigger>
      <PopoverContent className={className}>
        <PopoverHeader>
          {title}
          <PopoverCloseButton />
        </PopoverHeader>
        <PopoverBody className="whitespace-pre-wrap">{description}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
